import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';
import css from './PromptSuggestions.css';

const CARD_ICON_COLOR = 'var(--blue300)';
const LEADING_PUNCTUATION = /^[.,?!;:]/;

// Plain button on purpose: the Button atom's flat :hover rule strips the 1px border and forces its
// own gray hover background, which resizes the card and makes the centered layout jump on hover.
const PromptSuggestionCard = ({ card, onPick }) => (
    <button type="button" onClick={() => onPick(card)} className={css.promptCard}>
        <span className={css.promptCardBody}>
            <span className={css.cardHeader}>
                <Icon
                    name={card.icon}
                    type={IconTypes.TABLER}
                    size={IconSizes.SMALL}
                    style={{ color: CARD_ICON_COLOR }}
                />
                <span className={css.cardLabel}>{card.label}</span>
                {card.tag && <span className={css.cardTag}>{card.tag}</span>}
            </span>
            <span className={css.cardDescription}>
                {card.pre}
                {card.chip && (
                    <span
                        className={classNames(css.cardChip, {
                            [css.cardChipBeforePunctuation]: LEADING_PUNCTUATION.test(card.post),
                        })}
                    >
                        {card.chip}
                    </span>
                )}
                {card.post}
            </span>
        </span>
    </button>
);

PromptSuggestionCard.propTypes = {
    card: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        tag: PropTypes.string,
        pre: PropTypes.string.isRequired,
        chip: PropTypes.string,
        post: PropTypes.string.isRequired,
    }).isRequired,
    onPick: PropTypes.func.isRequired,
};

export default PromptSuggestionCard;
